import $ from "jquery"

$(() => {

  const sliderId = '#main-slider';
  const sliderEl = $(sliderId);
  const lightboxId = 'lightboxModal';
  const slickWrapper = '.wrap-modal-slider';
  const downloadFloorplanLink = $("#download_floorplan_link");

  const myModalEl = document.getElementById(lightboxId)

  downloadFloorplanLink.hide();

  myModalEl.addEventListener('shown.bs.modal', function (event) {
    const media = event.relatedTarget.dataset.lightboxMedia;

    if (media) {
      populateLightbox(JSON.parse(media));
      setTimeout(() => {
        initializeSlider();
        $(slickWrapper).addClass('open');
        window.dispatchEvent(new Event('resize'));
      }, 300);
    }
  });

  myModalEl.addEventListener('hide.bs.modal', function (event) {
    removeSlider();
    sliderEl.empty();
    $(slickWrapper).removeClass('open');
    downloadFloorplanLink.hide();
  });

  const mediaMapper = {
    "image": addImageMarkup,
    "video": addVideoMarkup,
    "floorplan": addFloorplanMarkup,
  }

  function initializeSlider() {
    sliderEl.on("init", (event, slider) => {
      changeFloorplanLink(slider, 0);
    });

    sliderEl.on("afterChange", (event, slider, currentSlide) => {
      changeFloorplanLink(slider, currentSlide);
    });

    sliderEl.slick({
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      adaptiveHeight: true
    });
  }

  function changeFloorplanLink(slider, slideNumber) {
    const url = $(slider.$slides[slideNumber]).find("[data-download-url]").data("download-url");
    if (url) {
      downloadFloorplanLink.attr("href", url);
      downloadFloorplanLink.show();
    }
  }

  function removeSlider() {
    sliderEl.slick('unslick');
    sliderEl.off();
  }

  function populateLightbox(mediaList) {
    sliderEl.empty();
    mediaList.forEach(media => {
      const markup = mediaMapper[media.media](media);
      sliderEl.append(`<div class="lightbox-item">${markup}</div>`);
    });
  }

  function addImageMarkup(image) {
    return `<img src="${image.src}">`;
  }

  function addVideoMarkup(video) {
    if (video.type === "embed") return video.src;
    return `<iframe src="${video.src}" style="height: 40rem" frameborder="0" allowfullscreen="allowfullscreen" allow="xr-spatial-tracking"></iframe>`
  }

  function addFloorplanMarkup(image){
    if (image.url) {
      return `<img data-download-url="${image.url}" class="pdf_thumbnail" src="${image.src}">`;
    }
  }

})
